/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ForwarderApproval } from '../models/ForwarderApproval';
import { HttpFile } from '../http/http';

export class TruckerForForwarderTO {
    'userId'?: string;
    'registeredDate'?: Date;
    'firstName'?: string;
    'lastName'?: string;
    'email'?: string;
    'licensePlate'?: string;
    'forwarderApproval'?: ForwarderApproval;
    'completedBookingsCount'?: number;
    'lastBookingCompletedDate'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "userId",
            "baseName": "userId",
            "type": "string",
            "format": ""
        },
        {
            "name": "registeredDate",
            "baseName": "registeredDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "firstName",
            "baseName": "firstName",
            "type": "string",
            "format": ""
        },
        {
            "name": "lastName",
            "baseName": "lastName",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "licensePlate",
            "baseName": "licensePlate",
            "type": "string",
            "format": ""
        },
        {
            "name": "forwarderApproval",
            "baseName": "forwarderApproval",
            "type": "ForwarderApproval",
            "format": ""
        },
        {
            "name": "completedBookingsCount",
            "baseName": "completedBookingsCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "lastBookingCompletedDate",
            "baseName": "lastBookingCompletedDate",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return TruckerForForwarderTO.attributeTypeMap;
    }

    public constructor() {
    }
}

